import { Component, OnInit, HostBinding } from '@angular/core';
import { ModalService, MODAL } from '../services/modal.service';

@Component({
  selector: 'ng-hbm-bdi-modals',
  templateUrl: './modals.component.html'
})
export class ModalsComponent implements OnInit {

  @HostBinding('class.open') get isOpen() { return this.modalService.currentId > MODAL.NONE; }
  @HostBinding('class.loading') get isLoading() { return this.modalService.isLoading; }

  constructor(public modalService: ModalService) { }

  MODAL: typeof MODAL = MODAL;

  ngOnInit(): void { }
}
